<template>
  <ContentView>
    <b-modal
      v-model="isModalActive"
      has-modal-card
      trap-focus
      aria-role="dialog"
      aria-label="JoinProjectBeforeAskingModal"
      :aria-modal="true"
      scroll="keep"
      class="JoinProjectBeforeAskingView"
      @close="cancelProjectCreation"
    >
      <div class="modal-card">
        <header class="modal-card-head">
          <H3TitleView class="modal-card-title"
            >{{ $t("myProjects.create-project.title").toString() }}
          </H3TitleView>
          <button
            type="button"
            class="delete"
            aria-label="close"
            @click="cancelProjectCreation"
          ></button>
        </header>
        <section class="modal-card-body">
          <div>
            <SingleEtablissement :etablissement="chosenEtablissement" />
            <div class="JoinProjectBeforeAskingView-infos">
              <b-icon icon="times-circle" type="is-danger" />
              <span>{{ $t("myProjects.create-project.etablissementWithProject") }}</span>
            </div>
            <div>
              <span>
                {{ $t("myProjects.create-project.etablissementWithProject1") }}
              </span>
            </div>
            <br />
            <div>
              <span>{{ $t("myProjects.create-project.etablissementWithProject2") }}</span>
            </div>
            <br />
            <div>
              <span>{{ $t("myProjects.create-project.etablissementWithProject4") }}</span>
            </div>
            <br />
            <div class="text-bold">
              <b>{{ $t("myProjects.create-project.etablissementWithProject3") }} </b>
            </div>
            <br />
            <div class="JoinProjectBeforeAskingView-cards">
              <div v-for="project in filteredProjects" :key="project.id">
                <EtablissementProjectCard :project="project" :logged-user="loggedUser" />
              </div>
            </div>
          </div>
          <b-loading v-model="isLoading" is-full-page />
        </section>
        <footer class="modal-card-foot">
          <div :class="`buttons`">
            <div class="modal-finish-buttons">
              <div class="hoverable-discrete-link" @click="cancelProjectCreation">
                {{ $t("annuler") }}
              </div>
              <b-button rounded type="is-link" :disabled="isLoading" @click="askForCreation">
                {{ $t("myProjects.create-project.create") }}
              </b-button>
              <b-button
                v-if="!isReferent"
                rounded
                type="is-primary"
                :disabled="isLoading"
                @click="confirmJoin"
              >
                {{ $t("myProjects.create-project.confirmJoin") }}
              </b-button>
            </div>
          </div>
        </footer>
      </div>
    </b-modal>
  </ContentView>
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue"
import ContentView from "@/views/commons/ContentView.vue"
import H3TitleView from "@/views/commons/H3TitleView.vue"
import { EtablissementDTO, ProjetAnnuelDTO, UtilisateurDTO } from "@/model/bean/GeneratedDTOs"
import SingleEtablissement from "../organisme/SingleEtablissement.vue"
import EtablissementProjectCard from "./EtablissementProjectCard.vue"
import { BButton, BIcon, BLoading, BModal } from "buefy"

export default defineComponent({
  name: "JoinProjectBeforeAskingView",
  components: {
    ContentView,
    H3TitleView,
    SingleEtablissement,
    EtablissementProjectCard,
    BButton,
    BIcon,
    BModal,
    BLoading,
  },
  props: {
    loggedUser: {
      type: Object as PropType<UtilisateurDTO>,
      required: true,
    },
    projectsInEtablissement: {
      type: Array as PropType<ProjetAnnuelDTO[]>,
      required: true,
    },
    chosenEtablissement: {
      type: Object as PropType<EtablissementDTO>,
      required: true,
    },
  },

  emits: ["confirm-join", "cancel-project-creation"],
  data() {
    return {
      filteredProjects: [] as ProjetAnnuelDTO[],
      isLoading: false,
      isReferent: false,
      isModalActive: true,
    }
  },
  watch: {
    projectsInEtablissement(): void {
      this.projectsInEtablissementChanged()
    },
  },
  mounted() {
    this.isModalActive = true
  },
  created(): void {
    this.projectsInEtablissementChanged()
    if (!this.filteredProjects || this.filteredProjects.length === 0) {
      this.$router.push("/myProjects")
    }
  },
  methods: {
    projectsInEtablissementChanged(): void {
      this.filteredProjects = this.projectsInEtablissement.filter(
        (p) => !p.enseignants.some((e) => e.id === this.loggedUser.id),
      )
    },

    askForCreation(): void {
      this.$router.push(`/myProjects/new/${this.chosenEtablissement.codeEtablissement}/ask`)
    },

    confirmJoin(): void {
      this.isLoading = true
      this.$emit("confirm-join")
    },

    cancelProjectCreation(): void {
      this.isLoading = true
      this.$emit("cancel-project-creation")
    },

    goPrevious(): void {
      this.$router.push("/myProjects/new")
    },
  },
})
</script>

<style lang="scss" scoped>
@import "@/styles/variables";

.JoinProjectBeforeAskingView {
  .modal-card {
    height: $create-project-modals-height;
    overflow-y: auto !important;
  }

  .animation-content {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
  }
}

.JoinProjectBeforeAskingView-infos {
  font-weight: 700;
  margin: 0.25rem 0;
  display: flex;
  align-items: center;
}

.JoinProjectBeforeAskingView-cards {
  display: flex;
  align-items: center;

  .text-bold {
    font-family: $font-family;
    font-style: normal;
    font-weight: 700;
    font-size: 18px;
    line-height: 23px;
  }

  .BookmarkCard {
    margin-left: 0.5rem;
  }
}
</style>
